import { Injectable } from '@angular/core';
import { ApiService } from '../common/services/api.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../auth/authentication.service';
import { map, first } from 'rxjs/operators';
import { CustomizerService } from '../common/services/customizer.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class PortalService {
    public loginProgress: boolean = false;
    public registerProgress: boolean = false;
    public quoteProductCode: string = "";
    webUserFatherName: string = "";
    constructor(private http: HttpClient,
        public translate: TranslateService,
        private modalService: NgbModal,
        private toastrService: ToastrService,
        private apiService: ApiService,
        private customizer: CustomizerService,
        private authenticationService: AuthenticationService,
        private spinner: NgxSpinnerService,
        private router: Router,
        private route: ActivatedRoute) {

        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};

        if (browserWindowEnv.hasOwnProperty('webUserFatherName') &&
            window['__env']['webUserFatherName'] == "true") {
            this.webUserFatherName = window['__env']['webUserFatherName'];
        }
    }

    public resetLanguage() {
        if (this.authenticationService.User == null) {
            const supportedLangs = ["en", "ar", "fr"];
            supportedLangs.forEach((language) => {
                this.translate.reloadLang(language);
            });

            const browserWindow = window || {};
            const browserWindowEnv = browserWindow['__env'] || {};
            if (browserWindowEnv.hasOwnProperty('defaultLangId')) {
                var defaultLangId = window['__env']['defaultLangId'];
                if (defaultLangId == "1") {
                    this.translate.setDefaultLang("en");
                    this.translate.use("en");
                    this.customizer.setLayoutType("ltr");
                } else if (defaultLangId == "2") {
                    this.translate.setDefaultLang("ar");
                    this.translate.use("ar");
                    this.customizer.setLayoutType("rtl");
                } else if (defaultLangId == "3") {
                    this.translate.setDefaultLang("fr");
                    this.translate.use("fr");
                    this.customizer.setLayoutType("ltr");
                }
            }
        } else if (this.translate.currentLang != this.authenticationService.User.Language) {
            var defaultLangId = this.translate.currentLang;
            if (defaultLangId == "1") {
                this.translate.setDefaultLang("en");
                this.translate.use("en");
                this.customizer.setLayoutType("ltr");
            } else if (defaultLangId == "2") {
                this.translate.setDefaultLang("ar");
                this.translate.use("ar");
                this.customizer.setLayoutType("rtl");
            } else if (defaultLangId == "3") {
                this.translate.setDefaultLang("fr");
                this.translate.use("fr");
                this.customizer.setLayoutType("ltr");
            }
        }
    }
    
    public login(modelLogin) {
        if (!this.validateLogin(modelLogin)) return;
        var endPoint = "Token";
        var userData = "username=" + modelLogin.EmailAddress + "&password=" + modelLogin.Password + "&grant_type=password";

        var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'No-Auth': 'True' });
        this.spinner.show();
        this.loginProgress = true;
        return this.http.post<any>(endPoint, userData, { headers: reqHeader })
            .pipe(map(user => {
                this.loginProgress = false;
                this.spinner.hide();
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                if (modelLogin.Remember)
                    localStorage.setItem('currentUser', JSON.stringify(user));

                this.authenticationService.next(user);

                //this.getUserConfig();
                if (user.Language) {
                    this.resetLanguage();
                }

                this.router.navigate(['/Portal/Home']);

            })).pipe(first())
            .subscribe(
                data => {
                    this.loginProgress = false;
                    this.spinner.hide();
                    this.modalService.dismissAll();
                    this.toastrService.info(this.translate.instant("Login successful"));
                },
                error => {
                    this.loginProgress = false;
                    this.spinner.hide();
                    this.toastrService.error(this.translate.instant("Failed to login"));
                });
    }

    public register(modelRegister) {
        if (!this.validateRegistration(modelRegister)) return;
        this.spinner.show();
        this.registerProgress = true;
        this.apiService.post("Api/WebUserAPI/SignUp", modelRegister).subscribe((result: any) => {
            this.registerProgress = false;
            this.spinner.hide();
            //localStorage.setItem('currentUser', JSON.stringify(user));
            if (result.ErrorCode != 0) {
                if (result.Message = "Email address already exist." || result.ErrorCode == 7)
                {
                    this.toastrService.error(this.translate.instant("Email address already exist."));
                    return false;
                }
                //var modelLogin: any = {};
                //modelLogin.EmailAddress = modelRegister.EmailAddress;
                //modelLogin.Password = modelRegister.Password;
                //this.login(modelLogin);
                //if ( !login(modelLogin) || result.ErrorCode == 7) { } 

                //if (modelRegister.EmailAddress = modelLogin.EmailAddress || result.ErrorCode == 7) { }


                //if (result.ErrorCode == 7) {

                //    this.toastrService.error(this.translate.instant("Email address already exist."));
                //}

                else {
                    this.toastrService.error(result.Message);
                }

            }
            else {
                this.modalService.dismissAll();
                this.toastrService.info(this.translate.instant("Registration successful"));
                //this.authenticationService.logout();
                //this.logout();
                //auto login after registration
                var modelLogin: any = {};
                modelLogin.EmailAddress = modelRegister.EmailAddress;
                modelLogin.Password = modelRegister.Password;
                this.login(modelLogin);
            }
        });
    }

    public logout() {
        this.authenticationService.logout();
        this.toastrService.info(this.translate.instant("Logout successful"));
        this.resetLanguage();
        window.location.reload();
        //this.router.navigate(['/Portal/Login']);
    }

    validateRegistration(modelRegister):boolean {
        if (!modelRegister) {
            this.toastrService.error(this.translate.instant("Please provide details for all required fields."));
            return false;
        }


        if (!modelRegister.FirstName || modelRegister.FirstName.length < 1) {
            this.toastrService.error(this.translate.instant("Provide valid first name."));
            return false;
        }

        if (!modelRegister.LastName || modelRegister.LastName.length < 3) {
            this.toastrService.error(this.translate.instant("Provide valid last name."));
            return false;
        }

        if (this.webUserFatherName == "true" && (!modelRegister.FatherName || modelRegister.FatherName.length < 3)) {
            this.toastrService.error(this.translate.instant("Provide valid father name."));
            return false;
        }

        const phoneRegex = new RegExp(/^\d+$/);
        if (!modelRegister.MobileNumber ||
            phoneRegex.test(modelRegister.MobileNumber.toString()) == false ||
            modelRegister.MobileNumber.toString().length < 5 ||
            modelRegister.MobileNumber.toString().length > 12 ) {
            this.toastrService.error(this.translate.instant("Provide valid phone number."));
            return false;
        }

        const emailRegEx = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
        if (!modelRegister.EmailAddress ||
            emailRegEx.test(modelRegister.EmailAddress) == false) {
            this.toastrService.error(this.translate.instant("Provide valid email address."));
            return false;
        }
        ///^[a-zA-Z0-9]+$/
        const passwordRegex = /^[a-zA-Z0-9]{5,16}$/;
        if (!modelRegister.Password ||
            passwordRegex.test(modelRegister.Password) == false) {
            this.toastrService.error(this.translate.instant("Password must be between 5-16 characters and it must contain number and character only"));
            return false;
        }


        return true;
    }

    validateLogin(modelLogin): boolean {
        if (!modelLogin || !modelLogin.EmailAddress || !modelLogin.Password) {
            this.toastrService.error(this.translate.instant("Provide email/password to login."));
            return false;
        }

        const emailRegEx = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
        if (!modelLogin.EmailAddress ||
            emailRegEx.test(modelLogin.EmailAddress) == false) {
            this.toastrService.error(this.translate.instant("Provide valid email address."));
            return false;
        }

        if (!modelLogin.Password ||
            modelLogin.Password.length < 5) {
            this.toastrService.error(this.translate.instant("Provide valid password."));
            return false;
        }


        return true;
    }

    validateForgotPassword(modelLogin): boolean {
        if (!modelLogin || !modelLogin.EmailAddress) {
            this.toastrService.error(this.translate.instant("Provide valid email address."));
            return false;
        }

        const emailRegEx = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
        if (!modelLogin.EmailAddress ||
            emailRegEx.test(modelLogin.EmailAddress) == false) {
            this.toastrService.error(this.translate.instant("Provide valid email address."));
            return false;
        }

        return true;
    }

    public forgotPassword(modelLogin) {
        if (!this.validateForgotPassword(modelLogin)) return;

        this.spinner.show();
        this.registerProgress = true;
        this.apiService.post("Api/WebUserAPI/Password", modelLogin).subscribe((result: any) => {
            this.registerProgress = false;
            this.spinner.hide();
            if (result == 1 || result == 0) {
                this.toastrService.info(this.translate.instant("If the eMail address you provided is correct you will recive the instruction to recover your password."));
                this.router.navigate(['/Portal/Login']);
            }
            else {
                this.toastrService.error(this.translate.instant("Unable to process your request."));
            }

        }, (error: any) => {
            this.registerProgress = false;
            this.spinner.hide();
            this.toastrService.error(this.translate.instant("Unable to connect.Please retry."));
        });
    }
}